<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col class="form-group" cols="12">
        <label
          for="exaborganizationlead_title"
          class="form-control-label">{{ $t('views.exaborganizationlead.form.title') }}</label>
        <input
          id="exaborganizationlead_title"
          v-model="item.title"
          placeholder=""
          :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
          @input="handleUpdateField('title', $event.target.value)"
        />
      </b-col>
      <b-col class="form-group" cols="12">
        <label
          for="exaborganizationlead_description"
          class="form-control-label">{{ $t('views.exaborganizationlead.form.description') }}</label>
        <input
          id="exaborganizationlead_description"
          v-model="item.description"
          placeholder=""
          :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
          @input="handleUpdateField('description', $event.target.value)"
        />
      </b-col>
      <b-col class="form-group" :cols="ableToUpdateUserData ? 8 : 12">
        <label
          for="exaborganizationlead_description"
          class="form-control-label">{{ $t('views.exaborganizationlead.form.idUserData') }}</label>
        <base-select-input
          :disabled="idUserData !== null"
          v-model="item.idUserData"
          :search-callback="userDataSearchCallback"
          :display-values="['fullName', 'firmname1']"
          :query-param="'userdata'"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></base-select-input>
      </b-col>
      <b-col :cols="item.idUserData ? 2 : 4" align-self="end" v-if="ableToUpdateUserData">
        <button
          type="button"
          class="btn btn-block btn-default mb-2"
          @click="showCreateContractorModal()"
        >
          {{ $t('menu.contractors.create') }}
        </button>
      </b-col>
      <b-col cols="2" v-if="ableToUpdateUserData && item.idUserData" align-self="end">
        <button
          type="button"
          class="btn btn-block btn-default mb-2"
          @click="toggleUpdateUserDataModal()"
        >
          {{$t('views.agreements.form.editContractor')}}
        </button>
      </b-col>
      <b-col class="form-group" cols="4">
        <label>{{ $t('views.firm.form.tags') }}:</label>
        <multi-select :options="tagOptions" :selected-options="item.tags" @select="onSelectTags"></multi-select>
      </b-col>
      <b-col class="form-group" cols="4">
        <label>{{ $t('views.exaborganizationlead.form.idStatus') }}:</label>
        <model-select :isDisabled="idStatus !== null" :options="statusOptions" v-model="item.idStatus"></model-select>
      </b-col>
      <b-col class="form-group" cols="4">
        <label>{{ $t('views.exaborganizationlead.form.idSalesOpportunity') }}:</label>
        <model-select :options="opportunityOptions" v-model="item.idSalesOpportunity"></model-select>
      </b-col>
      <b-col class="form-group" cols="4">
        <label>{{ $t('views.exaborganizationlead.form.idSalesRepresentative') }}:</label>
        <base-select-input
          v-model="item.idSalesRepresentative"
          :search-callback="userDataSearchCallback"
          :display-values="['fullName', 'firmname1']"
          :query-param="'userdata'"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></base-select-input>
      </b-col>
      <b-col class="form-group" cols="4">
        <label
          for="exaborganizationlead_monthlyCost"
          class="form-control-label">{{ $t('views.exaborganizationlead.form.monthlyCost') }}</label>
        <input
          type="number"
          id="exaborganizationlead_monthlyCost"
          v-model="item.monthlyCost"
          placeholder=""
          :class="['form-control', isInvalid('monthlyCost') ? 'is-invalid' : '']"
          @input="handleUpdateField('monthlyCost', $event.target.value)"
        />
      </b-col>
      <b-col class="form-group" cols="4">
        <label
          for="exaborganizationlead_yearlyCost"
          class="form-control-label">{{ $t('views.exaborganizationlead.form.yearlyCost') }}</label>
        <input
          type="number"
          id="exaborganizationlead_yearlyCost"
          v-model="item.yearlyCost"
          placeholder=""
          :class="['form-control', isInvalid('yearlyCost') ? 'is-invalid' : '']"
          @input="handleUpdateField('yearlyCost', $event.target.value)"
        />
      </b-col>
    </b-row>
    <create-contractor-modal></create-contractor-modal>
    <update-contractor-modal :id-user-data="item.idUserData"></update-contractor-modal>
    <div>
      <b-button @click="handleSubmit(item)" variant="success">
        {{ $t('buttons.submit') }}
      </b-button>
    </div>
  </form>
</template>

<script>

import { ModelSelect, MultiSelect } from 'vue-search-select'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import { checkPermission } from '@/utils/checkRoles'
import { mapGetters, mapMutations } from 'vuex'
import CreateContractorModal from '@/components/Dashboard/Views/firm/modals/CreateModal.vue'
import UpdateContractorModal from '@/components/Dashboard/Views/firm/modals/UpdateModal.vue'

export default {
  name: 'Form',
  components: {
    CreateContractorModal,
    UpdateContractorModal,
    BaseSelectInput,
    MultiSelect,
    ModelSelect
  },
  props: {
    idStatus: {
      type: String,
      required: false,
      default: null
    },
    idUserData: {
      type: String,
      required: false,
      default: null
    },
    handleSubmit: {
      type: Function,
      required: true
    },
    handleUpdateField: {
      type: Function,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      tagOptions: [],
      opportunityOptions: [],
      statusOptions: []
    }
  },
  computed: {
    ...mapGetters({
      createdContractor: 'userdata/create/created'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    },
    ableToUpdateUserData () {
      if (this.idUserData) {
        return false
      }
      return checkPermission('firms', 'FirmCreate')
    }
  },
  created () {
    this.fetchTagOptions()
    this.fetchSalesOpportunities()
    this.fetchStatuses()
  },
  watch: {
    createdContractor: {
      handler (val) {
        if (val) {
          this.item.idUserData = val['@id']
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      showCreateContractorModal: 'userdata/createModal/toggleModal',
      toggleUpdateUserDataModal: 'userdata/updateModal/toggleModal'
    }),
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async fetchTagOptions () {
      let params = { pagination: false, tagType: 2 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      this.tagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    async fetchSalesOpportunities () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('e_x_c_m_user_data_sales_opportunities', params).getResults()
      this.opportunityOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    async fetchStatuses () {
      let params = { pagination: false, state: 1 }
      const response = await new ApiService('e_x_c_m_user_data_statuses', params).getResults()
      this.statusOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    onSelectTags (items, lastSelectItem) {
      this.item.tags = items
      this.lastSelectTag = lastSelectItem
    }
  }
}
</script>
